// hooks/useCheckDuplicateTransporterName.js

import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Urls } from "../Urls";
import axios from "../Axios";

const CACHE_STALE_TIME = 1000 * 60 * 5; // 5 minutes

// ── Query Key Factory ────────────────────────────────────────────────────────
export const duplicateNameQueryKey = (name) => [    
    "transporter",
    "duplicate-check",
    { name },
];

// ── reusable outside the hook as well ───────────────────────
export const fetchIsDuplicateTransporterName = async (name) => {
    const res = await axios.post(Urls.Duplicate, { name });
    return res.data["Flag"] === true;
};


// ── Hook ─────────────────────────────────────────────────────────────────────
export const useCheckDuplicateTransporterName = () => {
    const queryClient = useQueryClient();

    const checkDuplicate = useCallback(
        (name) =>
            queryClient.fetchQuery({
                queryKey: duplicateNameQueryKey(name),
                queryFn: () => fetchIsDuplicateTransporterName(name),
                staleTime: CACHE_STALE_TIME,
            }),
        [queryClient]
    );

    return { checkDuplicate };
};